<template>
  <div class="block-dynamics">
    <div :data-form-block-id="dynamicsFormId" />
    <div :id="'d' + dynamicsId" />
  </div>
</template>

<script lang="ts" setup>
import { initScript } from './helper'

const SCRIPT =
  'https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.67.1044.0'

const props = defineProps<{
  dynamicsId: string
  dynamicsFormId: string
}>()

const { onLoaded } = useScript({
  src: SCRIPT,
  crossorigin: false,
  async: true,
  defer: true,
})

onLoaded(() => {
  initScript(
    props.dynamicsId,
    'https://559ba4298b9d455b93226c8f27ce5c42.svc.dynamics.com/f',
    'https://559ba4298b9d455b93226c8f27ce5c42.svc.dynamics.com/t',
    'https://559ba4298b9d455b93226c8f27ce5c42.svc.dynamics.com/t/w',
    // @ts-ignore
    typeof window.ms_tr_il_08 === 'undefined' ? null : window.ms_tr_il_08,
    // @ts-ignore
    typeof window.ms_tr_il_w_01 === 'undefined' ? null : window.ms_tr_il_w_01,
  )
})
</script>

<style lang="postcss">
.block-dynamics {
  [data-layout='true'] {
    @apply !m-0;

    &:focus,
    &:focus-within {
      @apply outline-0;
    }
  }

  [data-section='true'],
  [data-container='true'] {
    @apply !p-0;
  }

  [data-container='true'] {
    @apply mb-[0.75rem];
  }

  [data-editorblocktype='Text'] {
    @apply text-[16px];

    big {
      @apply text-[1.25rem] font-bold;
    }
  }

  [data-container-width='50'] {
    @apply mr-[10px];
    width: calc(50% - 10px) !important;
  }

  [data-editorblocktype='Field-date'],
  [data-editorblocktype='Field-dropdown'],
  [data-editorblocktype='Field-text'],
  [data-editorblocktype='Field-email'] {
    margin-bottom: 0.75rem;
    padding-bottom: 1.6875rem;
  }

  [data-editorblocktype='Field-date'],
  [data-editorblocktype='Field-dropdown'],
  [data-editorblocktype='Field-text'],
  [data-editorblocktype='Field-email'] {
    .lp-form-fieldInput {
      @apply m-0 w-full max-w-full shadow-none;
      font-family: $family-sans-serif;
    }

    .lp-form-fieldInput {
      @apply relative inline-flex items-center justify-start border-2 border-solid border-border bg-background align-top text-[1rem] text-button-color focus-visible:outline-border-hover;
      -moz-appearance: none;
      -webkit-appearance: none;
      height: 3em;
      line-height: 1.5;
      padding: calc(0.75em - 2px) calc(1em - 2px);
      border-radius: 1px;
    }
  }

  [data-editorblocktype='Field-dropdown'] {
    .lp-form-field {
      @apply relative;

      &:after {
        @apply inline-block border-0 bg-primary;
        content: '';
        mask-image: url('~/assets/symbols/chevron-down.svg');
        mask-size: 1rem 1rem;
        mask-position: center;
        mask-repeat: no-repeat;
        position: absolute;
        bottom: 0px;
        right: 0.75em;
        margin: 0;
        width: 1.5em;
        height: 1.5em;
        transform: translateY(-50%);
        pointer-events: none;
      }
    }
  }

  [data-editorblocktype='SubscriptionListBlock'],
  [data-editorblocktype='Field-checkbox'] {
    .marketing-subscription-list,
    .lp-form-field {
      @apply flex flex-row items-baseline;
    }
    .lp-form-fieldInput {
      margin-right: 1em;
    }
    .lp-ellipsis {
      @apply font-normal text-scheme-light;
    }
  }

  .lp-ellipsis {
    @apply block text-[1rem] font-bold text-scheme-invert;

    a {
      @apply mx-1 my-0;
    }

    &:not(:last-child) {
      margin-bottom: 0.5em;
    }
  }

  .lp-required {
    @apply hidden;
  }

  [data-required-field='true'] {
    .lp-ellipsis:after {
      content: '*';
      @apply pl-1;
    }
  }

  .lp-form-button {
    @apply relative inline-flex cursor-pointer items-center justify-center whitespace-nowrap border-2 border-transparent bg-primary text-center align-top text-[1rem] font-bold text-white shadow-none;
    min-width: 3em;
    padding: calc(0.5em - 2px) 1em;
    -moz-appearance: none;
    height: 3em;
    line-height: 1.5;
  }
}
</style>
